import { render, staticRenderFns } from "./WorkRecordDetailDialog.vue?vue&type=template&id=0fda294c&scoped=true"
import script from "./WorkRecordDetailDialog.vue?vue&type=script&lang=js"
export * from "./WorkRecordDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordDetailDialog.vue?vue&type=style&index=0&id=0fda294c&prod&scoped=true&lang=css"
import style1 from "./WorkRecordDetailDialog.vue?vue&type=style&index=1&id=0fda294c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda294c",
  null
  
)

export default component.exports